module.exports = __webpack_public_path__ + "media/bell.ccc0629a.mp3";